import { CustomFieldValue } from '../../../../../types/custom_field';
import { StockLocation } from '../../../../../types/stock_location';
import { PdfFieldEntity } from '../PdfDataKey';
import { PdfEntityDataResolver } from '../PdfEntityDataResolver';

enum PdfStockLocationProperty {
  name = 'name',
  identifier = 'identifier',
  addressLine1 = 'addressLine1',
  addressLine2 = 'addressLine2',
  city = 'city',
  postalCode = 'postalCode',
  country = 'country',
}

export class PdfStockLocationDataResolver extends PdfEntityDataResolver<StockLocation, PdfStockLocationProperty> {
  properties = Object.values(PdfStockLocationProperty);
  entityType = PdfFieldEntity.stockLocation;

  getCustomFieldByEntity(entity: StockLocation, id: string): CustomFieldValue | undefined {
    throw new Error('Stock locations do not support custom fields.');
  }

  getLabelByProperty(key: PdfStockLocationProperty): string {
    switch (key) {
      case PdfStockLocationProperty.name:
        return 'Stock Location Name';
      case PdfStockLocationProperty.identifier:
        return 'Stock Location Identifier';
      case PdfStockLocationProperty.addressLine1:
        return 'Stock Location Address Line 1';
      case PdfStockLocationProperty.addressLine2:
        return 'Stock Location Address Line 2';
      case PdfStockLocationProperty.city:
        return 'Stock Location City';
      case PdfStockLocationProperty.postalCode:
        return 'Stock Location Postal Code';
      case PdfStockLocationProperty.country:
        return 'Stock Location Country';
    }
  }

  getValueByProperty(key: PdfStockLocationProperty, stockLocation: StockLocation): string {
    switch (key) {
      case PdfStockLocationProperty.name:
        return stockLocation.name || '';
      case PdfStockLocationProperty.identifier:
        return stockLocation.identifier || '';
      case PdfStockLocationProperty.addressLine1:
        return stockLocation.address?.addressLine1 || '';
      case PdfStockLocationProperty.addressLine2:
        return stockLocation.address?.addressLine2 || '';
      case PdfStockLocationProperty.city:
        return stockLocation.address?.city || '';
      case PdfStockLocationProperty.postalCode:
        return stockLocation.address?.postalCode || '';
      case PdfStockLocationProperty.country:
        return stockLocation.address?.countryCode || '';
    }
  }
}
